import React from "react";
import TypeJoin from "../../login/component/typeJoin";
import { Container } from "../login/styled";
import { useOutletContext, useParams } from "react-router";

const ShoppingType = () => {
  const { url } = useParams();
  const { homepageInfo, theme } = useOutletContext();

  return (
    <Container className={`theme-${theme}`}>
      <TypeJoin homepageInfo={homepageInfo} url={url} />
    </Container>
  );
};

export default ShoppingType;
